import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shipd.svg'


const _withScopeId = n => (_pushScopeId("data-v-3765f946"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logotyp"
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VerifyEmailOk = _resolveComponent("VerifyEmailOk")!
  const _component_UserActionInvalid = _resolveComponent("UserActionInvalid")!
  const _component_ResetPassword = _resolveComponent("ResetPassword")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        ($setup.route.query.mode == 'verifyEmail')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($setup.showOk)
                ? (_openBlock(), _createBlock(_component_VerifyEmailOk, { key: 0 }))
                : (_openBlock(), _createBlock(_component_UserActionInvalid, {
                    key: 1,
                    error: $setup.showError
                  }, null, 8, ["error"]))
            ]))
          : ($setup.route.query.mode == 'resetPassword')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!$setup.showError)
                  ? (_openBlock(), _createBlock(_component_ResetPassword, {
                      key: 0,
                      parameters: $setup.route.query,
                      email: $setup.userEmail
                    }, null, 8, ["parameters", "email"]))
                  : (_openBlock(), _createBlock(_component_UserActionInvalid, {
                      key: 1,
                      error: $setup.showError
                    }, null, 8, ["error"]))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_UserActionInvalid, { error: $setup.showError }, null, 8, ["error"])
              ]))
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}